import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { api } from '@app/api';
import { RootState } from 'src/store';

export const deleteMicrodistrictThunk = createAsyncThunk<number, number>("@@microdistricts/delete", async (id) => {
	await api.microdistrict.delete(id)
	return id
})

export function deleteMicrodistrictThunkPending(state: RootState["geoGuidMicrodistrictsSlice"]) {
	state.deleteMicrodistrictIsLoading = true
}

export function deleteMicrodistrictThunkRejected(state: RootState["geoGuidMicrodistrictsSlice"]) {
	state.deleteMicrodistrictIsLoading = false
}

export function deleteMicrodistrictThunkFullfilled(state: RootState["geoGuidMicrodistrictsSlice"], { payload }: PayloadAction<number>) {
	state.deleteMicrodistrictIsLoading = false
	state.microdistricts = state.microdistricts.filter(m => m.id !== payload)
	state.deleteMicrodistrictIsSuccess = true
}
